/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import Select, { components } from 'react-select';

import { CURRENCY_LIST } from '../../constants';

const customStyles = {
  input: (styles) => ({ ...styles, border: 'none !important' }),
};

const DropdownIndicator = (
  props
) => (
  <components.DropdownIndicator {...props}>
    <i className="fa fa-lg fa-usd" aria-hidden="true"></i>
  </components.DropdownIndicator>
  );


const CurrencySelector = (props) => {
  const list = CURRENCY_LIST;

  const value = find(list, (i) => i.Symbol === props.value) || null;
  return (
    <Select
      menuPlacement={props.menuPlacement || 'top'}
      menuContainerStyle={{ zIndex: 100 }}
      maxMenuHeight={props.maxHeight || 200}
      components={{ DropdownIndicator }}
      name={props.name}
      isMulti={false}
      isDisabled={props.disabled}
      value={value}
      onChange={(v) => {
        if (v) {
          props.onChange(v.Symbol);
        } else {
          props.onChange('');
        }
      }}
      className="react-select-container"
      classNamePrefix="react-select"
      styles={[customStyles, props.style]}
      filterOption={(v, r) => {
        if (!r) {
          return v;
        }
        if (v.label.toLowerCase().includes(r.toLowerCase())) {
          return v;
        }
      }}
      getOptionLabel={(option) => `${option.Symbol} - ${option.Title}`}
      getOptionValue={(option) => option.Symbol}
      placeholder="Type a currency"
      options={list}
    />
  );
};

CurrencySelector.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  style: PropTypes.any,
  maxHeight: PropTypes.any,
  menuPlacement: PropTypes.string,
};

export default CurrencySelector;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/CurrencySelector/index.js